import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast as toastify } from 'react-toastify';
// @mu
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/iconify';
import { useTranslation } from 'react-i18next';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import crypt from 'src/utils/service/crypt';
import Loader from 'src/components/loader/loader';

// ----------------------------------------------------------------------

export default function LoginForm({ setForgotPassword, isForgotPassword, infoSession }) {
    const navigate = useNavigate();

    const { t } = useTranslation();
    const [flagGetStat, setFlagGetStat] = useState(false);
    const loginFlag = useRef(false);
    const [value, setValue] = useState({
        username: '',
        password: '',
        email: '',
    });
    const dataRememberRef = useRef({
        username: '',
        password: '',
        email: '',
        checked: false,
    });
    const KEY = 'REMEMBER_OBJECT';
    const [checkedRemember, setCheckedRemember] = useState(false);
    useEffect(() => {
        handleSetDataRemember();
        const userData = sessionStorage.getItem('proc_data');
        const menu = sessionStorage.getItem('menu');
        if (userData && menu) {
            navigate('/home');
        }
    }, []);
    const handleSetDataRemember = () => {
        const dataRemember = localStorage.getItem(KEY);
        try {
            const dataParse = JSON.parse(dataRemember);
            if (!dataParse) return;
            console.log('dataParse', dataParse);
            dataRememberRef.current = {
                username: dataParse?.username || '',
                password: dataParse?.password || '',
                email: dataParse?.email || '',
                checked: dataParse?.checked || false,
            };
            setCheckedRemember(dataRememberRef.current.checked);
            setValue({
                username: dataRememberRef.current?.username,
                password: dataRememberRef.current?.password,
                email: dataRememberRef.current?.email,
            });
        } catch (error) {
            console.log('LỖI REMEMBER: ', error);
        }
    };

    const handleOnChange = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value });
    };

    const [showPassword, setShowPassword] = useState(false);

    const handleKeyDown = (e) => {
        // Check if the pressed key is "Enter" (key code 13)
        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
            // Call the onEnterPress function if it's provided
            // alert('ok');
            handleClick();
        }
    };
    const handleClick = () => {
        if (loginFlag.current === true) return;
        if (!value.username || value.username.trim() === '') {
            toastify.error(t('error.username'));
            return;
        } else if (!value.password || value.password.trim() === '') {
            toastify.error(t('error.pass'));
            return;
        }

        if (loginFlag.current) return;
        loginFlag.current = true;
        setFlagGetStat(true);

        // Request fullscreen directly on user click gesture if not already fullscreen
        const isCurrentlyFS = !!(
            document.fullscreenElement ||
            document.mozFullScreenElement ||
            document.webkitFullScreenElement ||
            document.msFullscreenElement
        );
        if (!isCurrentlyFS) {
            const docEl = document.documentElement;
            const requestFullScreen =
                docEl.requestFullscreen ||
                docEl.mozRequestFullScreen ||
                docEl.webkitRequestFullscreen ||
                docEl.msRequestFullscreen;
            if (requestFullScreen) {
                requestFullScreen.call(docEl).catch(err => {
                    console.log('Failed to enter fullscreen on login gesture:', err);
                });
            }
        }

        const InVal = [value.username, btoa(unescape(encodeURIComponent(value.password))), JSON.stringify(infoSession)];
        sendRequest(serviceList.login, InVal, loginResult, true, timeOutFunct, 40000);
        if (checkedRemember) {
            dataRememberRef.current = { ...value, checked: checkedRemember };
            localStorage.setItem(KEY, JSON.stringify(dataRememberRef.current));
        } else {
            dataRememberRef.current = {
                username: '',
                password: '',
                email: '',
                checked: checkedRemember,
            };
            localStorage.setItem(KEY, JSON.stringify(dataRememberRef.current));
        }
    };

    const loginResult = (reqInfoMap, message) => {
        loginFlag.current = false;
        setFlagGetStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toastify.error('Error: ' + message['proc_message'], { autoClose: 10000 });
            return;
        } else {
            const data = message.proc_data.rows[0].o_1;
            const menu = message.proc_data.rows[0].o_2;
            console.log('data: ', data);
            console.log('menu: ', menu);
            if (data && menu) {
                const enCode = crypt.enCode(JSON.stringify(data));
                const enCodeMenu = crypt.enCode(
                    JSON.stringify([
                        ...menu,
                        {
                            navigate: '/home/category/',
                            screens: 'Giỏ hàng',
                            screens_key: 'gio_hang',
                            user_id: 0,
                            permiss_screen: {},
                            company_id: 100,
                            id: 100,
                            department_id: 100,
                            icons: 'material-symbols:shopping-cart',
                        },
                    ])
                );
                sessionStorage.setItem('proc_data', enCode);
                sessionStorage.setItem('menu', enCodeMenu);
                glb_sv.sessionInfo.comp_id = data.o_3;
                glb_sv.sessionInfo.branch_id = data.o_4;
                glb_sv.sessionInfo.user_id = data.id;

                glb_sv.userInfo = data;
                glb_sv.menu = menu;
                loginIOT();
                navigate('/home', { replace: true });
            } else {
                toastify.error(t('system_reject_login'));
            }
        }
    };
    const handleForgotPassword = () => {
        if (loginFlag.current === true) return;

        if (!value.email || value.email.trim() === '') {
            toastify.error(t('error.email'));
            return;
        }

        if (loginFlag.current) return;
        loginFlag.current = true;
        setFlagGetStat(true);
        const InVal = [value.email];
        sendRequest(serviceList.forgot, InVal, forgotPassResult, true, timeOutFunct, 40000);
    };

    const forgotPassResult = (reqInfoMap, message) => {
        loginFlag.current = false;
        setFlagGetStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toastify.error(message['proc_message']);
            return;
        } else {
            toastify.success(message['proc_message']);
            setForgotPassword(!isForgotPassword);
        }
    };

    const timeOutFunct = (reqInfo) => {
        loginFlag.current = false;
        setFlagGetStat(false);
        toastify.error(t('error.time_out'));
    };
    const onChangeRemmember = (e) => {
        console.log('onChangeRemmember', e.target?.checked);
        setCheckedRemember(e.target.checked || false);
    };

    // region CALL API login IOT

    const loginIOT = () => {
        const cabinet_cd = glb_sv.getLocalStorageCabinet('cabinet');
        // console.log('cabinet_cd', cabinet_cd);
        // console.log('cabinet_cd', localStorage.getItem('cabinet_8'));
        sendRequest(
            serviceList.loginIOT,
            [cabinet_cd?.cabinet_cd || ''],
            loginIOTResult,
            true,
            timeOutFunctIOT,
            10000,
            0
        );
    };
    const loginIOTResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toastify.error('Error: ' + message['proc_message']);
        } else {
            toastify.success('Error: ' + message['proc_message']);
        }
    };
    const timeOutFunctIOT = (e) => {
        toastify.error(t('error.time_out') + ' IOT');
    };
    return (
        <>
            <Loader loading={flagGetStat} />
            {isForgotPassword ? (
                <Stack spacing={3}>
                    <TextField required value={value.email} name="email" onChange={handleOnChange} label="Email" />
                </Stack>
            ) : (
                <Stack spacing={3}>
                    <TextField
                        required
                        value={value.username.toLocaleLowerCase()}
                        name="username"
                        onKeyDown={handleKeyDown}
                        onChange={handleOnChange}
                        label={t('name_login')}
                    />

                    <TextField
                        name="password"
                        required
                        label={t('enter_pass')}
                        value={value.password}
                        onKeyDown={handleKeyDown}
                        onChange={handleOnChange}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Stack>
            )}

            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 1 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            name="remember"
                            checked={checkedRemember}
                            onChange={onChangeRemmember}
                            label={t('remember')}
                        />
                    }
                    color="primary"
                    label={
                        <Link variant="subtitle2" underline="none">
                            {t('remember')}
                        </Link>
                    }
                />
                <Link
                    variant="subtitle2"
                    underline="hover"
                    onClick={() => {
                        setValue({
                            username: '',
                            password: '',
                            email: '',
                        });
                        setForgotPassword(!isForgotPassword);
                    }}
                >
                    {!isForgotPassword ? t('forgot_pass') : t('back_login')}
                </Link>
            </Stack>

            {isForgotPassword ? (
                <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleForgotPassword}>
                    {t('forgot_pass')}
                </LoadingButton>
            ) : (
                <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleClick}>
                    {t('login')}
                </LoadingButton>
            )}
        </>
    );
}
